<script lang="ts">
  import type { SettlementDetails } from "../types";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../../components/workflow/ContinueButton.svelte";
  import DownloadLink from "../../Settlement/elements/DownloadLink.svelte";
  import OfferBreakdown from "../elements/OfferBreakdown.svelte";
  import { formatGbp } from "../../../lib/formatting";
  import Lock from "~icons/ph/lock-bold";

  let {
    settlementDetails,
  }: {
    settlementDetails: SettlementDetails;
  } = $props();
</script>

<h2 class="ui-title">Confirm fees</h2>

<p>
  To accept the offer, please confirm the fee of <b>{formatGbp(settlementDetails.jlgFeeAmount)}</b> + VAT for JLG’s services.
</p>

<h3 class="ui-section-title mb-4">Statute bill</h3>

<div class="ui-content-options border rounded-lg mb-4 overflow-clip">
  <div class="flex items-center justify-center text-gray-400">
    <span class="loading loading-spinner loading-lg"></span>
  </div>
  <img
    src={settlementDetails.statuteBillEmbedUrl}
    alt="Statute bill"
    onload={(e) => ((e.currentTarget.previousElementSibling! as HTMLElement).style.visibility = "hidden")}
    class="aspect-[0.77] w-full" />
</div>

<DownloadLink label="Download statute bill" href={settlementDetails.statuteBillUrl} />

<h3 class="ui-section-title mb-4">Summary</h3>

<OfferBreakdown {settlementDetails} class="mb-4">
  <div class="ui-alert ui-alert-success">
    <Lock />
    Your claim is protected by the SRA fee cap.
  </div>
</OfferBreakdown>

<label class="flex items-start gap-2 text-sm font-medium text-gray-600 bg-gray-100 p-2 rounded-lg">
  <input type="checkbox" name="settlement_financial[offer_status]" value="accepted"  class="checkbox bg-white scroll-mb-60" required />
  I have viewed my statute bill and agree to the deduction of JLG's legal costs of {formatGbp(settlementDetails.jlgFeeAmount)}
  + VAT from my compensation. I acknowledge that I will be paid {formatGbp(settlementDetails.payoutAmount)}.
</label>

<FooterButtons>
  <ContinueButton label="Accept offer & continue" name="settlement_financial[offer_status]" value="accepted" />
</FooterButtons>
